import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Form from './Form'
import { formTypeList } from '../../constants/form'
import { GET_ONE_ITEM_CATEGORY } from '../../store/types'
import { getOneItemCategory } from '../../store/actions/itemCategoryAction'

const Edit = ({ id, setOpen }) => {
    const dispatch = useDispatch()
    const { itemCategory } = useSelector((state) => state.itemCategory)
    useEffect(() => {
        dispatch(getOneItemCategory(id))
        return () => {
            dispatch({
                type: GET_ONE_ITEM_CATEGORY,
                payload: null,
            })
        }
    }, [dispatch, id])
    return itemCategory ? (
        <Form
            formType={formTypeList.EDIT}
            setOpen={setOpen}
            propsValue={itemCategory}
        />
    ) : null
}

export default Edit
